import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  isSaving: [],
  error: null,
  data: {
    assets: []
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_FALLBACK_ASSETS:
      return { ...state, isLoading: true };
    case Constants.REQUEST_SAVE_FALLBACK_ASSET:
      if (state.isSaving.indexOf(action.assetType) < 0) {
        return {
          ...state,
          isSaving: [...state.isSaving, action.assetType],
          isClearing: !!action.clearFallback
        };
      }
      return state;
    case Constants.RECEIVE_SAVE_FALLBACK_ASSET:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }

      const isSaving = [...state.isSaving.filter(t => t !== action.assetType)];
      return {
        ...state,
        isSaving,
        isClearing: false,
        data: {
          ...state.data,
          savedAsset: action.data.uuid
        }
      };
    case Constants.RECEIVE_FALLBACK_ASSETS:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          assets: action.data.assets
        }
      };
    default:
      return state;
  }
}
